import { Route, RouteGroup as group } from './base';
export const TOP = Route('/');
export const SIGNUP = Route('/signup');
export const SIGNUP_V2 = Route('/signup_v2');
export const SIGNIN = Route('/signin');
export const CC_REGISTRATION = Route('/cc_registration');
export const GOAL_MATCHING_ASSESSMENT = Route('/goal_matching_assessment');
export const SIGNUP_MATCHING_ASSESSMENT = Route('/signup_matching_assessment');
export const PROGRAM = Route('/programs/:slug').with();
export const PROGRAMS = Route('/programs');
export const PLAYLIST = Route('/playlists/:id').with();
export const PLAYLISTS = Route('/playlists');
export const ORIGINAL_PLAYLIST = Route('/original_playlists/:id').with();
export const ORIGINAL_PLAYLIST_UPDATE = Route('/original_playlists/:id/edit').with();
export const NEW_PLAYLIST = Route('/new_playlist');
export const LESSON = Route('/lessons/:slug/:type').with();
export const PLAN_CHANGE = Route('/account/plan_change');
export const PLAN_CHANGE_UNSUBSCRIBE_CP = Route('/account/plan_change_unsubscribe_cp');
export const COACHING_PLAN_UNSUBSCRIBE = Route('/account/coaching_plan_unsubscribe');
export const INVITATION = Route('/invitation');
export const EMAIL_VERIFICATION = Route('/email_verification');
export const UNSUBSCRIBE_CAUTION = Route('/unsubscribe_caution');
export const UNSUBSCRIBE_CONFIRM = Route('/unsubscribe_confirm');
export const PASSWORD_RESET_REQUEST = Route('/password_reset_request');
export const PASSWORD_RESET = Route('/password_reset');
export const ACTIVITY = Route('/activity');
export const MISSIONS = Route('/missions');
export const PLAYLIST_CERTIFICATES = Route('/playlist_certificates');
export const MAGAZINE_UNSUBSCRIBE = Route('/magazine_unsubscribe/:token').with();
export const SEARCH = Route('/search');
export const MERCHANDISE = Route('/merchandise');
export const RANKING = Route('/ranking');
export const CALLBACK_LINE = Route('/line_callback');
export const CALLBACK_CONNECT_LINE = Route('/line_connect_callback');
export const CALLBACK_APPLE = Route('/apple_callback');
export const CALLBACK_AMAZON_PAY = Route('/amazon_pay_callback');
export const CALLBACK_AMAZON_PAY_FOR_SIGNUP = Route('/amazon_pay_callback_for_signup');
export const SEARCH_RESULT = Route('/search/result');
export const TRAINERS = Route('/trainers');
export const INSTRUCTOR = Route('/instructor/:id').with();
export const LP_IFRAME = Route('/lp_iframe');
export const CHECK_EMAIL = Route('/check_email');
export const MEGALOS_LIVE_CALENDAR = Route('/megalos_live_calendar');
export const FUTURE_USER = Route('/future_user');
export const ANNOUNCEMENT_LIST = Route('/announcements');
export const ANNOUNCEMENT_DETAIL = Route('/announcements/:id').with();
export const LIVE_SCHEDULE = Route('/live_schedule');
export const LIVE_LESSON = Route('/live_lessons/:id').with();
export const USER_SEASON_RANK_HELP = Route('/user_season_rank_help');
export const LEAGUE_LEADERBOARD = Route('/league');
export const INITIAL_GUIDE = Route('/initial_guide');
export const INITIAL_GUIDE_DETAIL = Route('/initial_guide_detail');
export const LIVE_LESSON_VIMEO = Route('/live_lessons/:id/vimeo').with();
export const DORMANT = Route('/dormant');
export const TWITTER_CALLBACK = Route('/twitter_callback');
export const BILLYS_STUDIO = Route('/billys_studio');
export const SETTING = Route('/setting');
export const MY_LESSON = Route('/my_lesson');
export const MAINTENANCE = Route('/maintenance');
export const COUNT_LESSONS = Route('/count_lessons');
export const COUNT_LESSON_DETAIL = Route('/count_lessons/:id').with();
export const DAILY_START = Route('/daily_start').with();
export const DAILY_START_VOLUME = Route('/daily_start/volumes/:id').with();
export const DAILY_TASKS = Route('/daily_tasks/:taskName').with();
export const DAILY_TASKS_SUBTASK = Route('/daily_tasks/:taskName/:subtaskName').with();
export const CHART_TASKS = Route('/chart_tasks/:taskName/:chartType').with();
export const ANDROID_DELETE_ACCOUNT = Route('/delete_account');
export const COACHING = Route('/coaching');
export const NUTRIENTS = Route('/nutrients');
export const MEAL_SCORE = Route('/meal_score');
export const TV_LOGIN = Route('/tv_login');
export var LessonType;
(function (LessonType) {
    LessonType["normal"] = "normal";
})(LessonType || (LessonType = {}));
export const DailyTasksPageTaskName = {
    meal: 'meal',
    workout: 'workout',
    steps: 'steps',
    weight: 'weight',
};
export const MealSubtaskPageName = {
    breakfast: 'breakfast',
    lunch: 'lunch',
    dinner: 'dinner',
    snacking: 'snacking',
};
export const ChartTaskPageChartType = {
    weekly: 'weekly',
    monthly: 'monthly',
    quarterly: 'quarterly',
};
/**
 * 認証不要画面のRouteGroup
 */
export const UNRESTRICTED_ROUTE_GROUP = group([
    SIGNUP,
    SIGNUP_V2,
    SIGNIN,
    GOAL_MATCHING_ASSESSMENT,
    SIGNUP_MATCHING_ASSESSMENT,
    EMAIL_VERIFICATION,
    PASSWORD_RESET_REQUEST,
    PASSWORD_RESET,
    CALLBACK_LINE,
    CALLBACK_APPLE,
    CALLBACK_AMAZON_PAY_FOR_SIGNUP,
    LP_IFRAME,
    TV_LOGIN,
]);
/**
 * 認証画面のRouteGroup
 */
export const AUTH_ROUTE_GROUP = group([SIGNUP, SIGNUP_V2, SIGNIN]);
/**
 * クレカ登録関連のRouteGroup
 */
export const SELECT_PAGE = group([SIGNUP_V2, CC_REGISTRATION, CALLBACK_AMAZON_PAY, CALLBACK_AMAZON_PAY_FOR_SIGNUP]);
export const FUTURE_USER_PAGE = group([FUTURE_USER]);
/**
 * 休眠会員の人がアクセスできるRouteGroup
 */
export const DORMANT_ALLOWED_ROUTE_GROUP = group([
    PLAN_CHANGE,
    UNSUBSCRIBE_CAUTION,
    PASSWORD_RESET_REQUEST,
    PASSWORD_RESET,
    EMAIL_VERIFICATION,
    SETTING,
]);
export const AB_TEST_ROUTE_GROUP = group([SIGNUP, PROGRAM, LESSON]);
export const ORIGINAL_PLAYLIST_GROUP = group([ORIGINAL_PLAYLIST, ORIGINAL_PLAYLIST_UPDATE]);
export const LIVE_GROUP = group([LIVE_LESSON, LIVE_SCHEDULE]);
export const ACTIVITY_GROUP = group([ACTIVITY, MISSIONS, PLAYLIST_CERTIFICATES]);
export const SEARCH_GROUP = group([SEARCH, SEARCH_RESULT, PROGRAMS, PLAYLISTS, MERCHANDISE, RANKING]);
export const ANNOUNCEMENT_GROUP = group([ANNOUNCEMENT_LIST, ANNOUNCEMENT_DETAIL]);
/**
 * 認証ステータスによってリダイレクトを行わないRouteGroup
 */
export const NOT_HANDLE_REDIRECT_GROUP = group([MAINTENANCE, MAGAZINE_UNSUBSCRIBE]);
export const COURSE_DAY_LESSON_ID_QUERY_PARAM_KEY = 'course_day_lesson_id';
// 自動再生を無効化（トグル非表示＋常にOFF）することを示すクエリ
export const HIDE_AUTO_PLAY_QUERY_PARAM_KEY = 'hide_auto_play';
export const generateLessonQueryParams = (courseDayLessonID) => {
    const params = new URLSearchParams();
    if (courseDayLessonID != null) {
        params.set(COURSE_DAY_LESSON_ID_QUERY_PARAM_KEY, String(courseDayLessonID));
    }
    const query = params.toString();
    return query ? `?${query}` : '';
};
// 既存のレッスンクエリ文字列に自動再生無効化のパラメータを付与する。
// generateLessonQueryParams などの結果を受け取って合成できる: hideAutoPlay(generateLessonQueryParams(id))
export const hideAutoPlay = (query = '') => {
    const params = new URLSearchParams(query.startsWith('?') ? query.slice(1) : query);
    params.set(HIDE_AUTO_PLAY_QUERY_PARAM_KEY, '1');
    const result = params.toString();
    return result ? `?${result}` : '';
};
